enum CardStatus {
  ORDER_IN_PROCESS = 'ORDER_IN_PROCESS',
  RENEWED = 'RENEWED',
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE',
  BLOCKED = 'BLOCKED',
  REPLACED = 'REPLACED',
  NEW_CARD_ORDERED = 'NEW_CARD_ORDERED',
}

export default CardStatus;
